export const TypeSorting = [
        {id: 1, valor: "Mais votadas"},
        {id: 2, valor: "Mais recentes"},
        {id: 3, valor: "Em alta"},
    ];